export const triggerConfetti = async (origin: { x: number; y: number }) => {
    const { default: confetti } = await import('canvas-confetti');
    confetti({
        particleCount: 150,
        spread: 100,
        origin,
        colors: ['#D64045', '#FEFBF6', '#374151']
    });
};
